
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[product_slug]",
      function () {
        return require("private-next-pages/product/[product_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[product_slug]"])
      });
    }
  